export default __webpack_public_path__ + "static/media/move_icon.8c3aca87.svg";